import {takeLatest, call, put} from 'redux-saga/effects';
import {

    API_GET_LAYOUT,

} from '../actions/apiActions';
import {errors,setData,setLoading} from "../features/layout/LayoutSlice";

import {
    fetchLayoutData,

} from "../../api/layout";

// Hàm thực hiện cuộc gọi API (có thể sử dụng fetch, axios, v.v.)
//đổi thành hàm base api của mình




// Saga worker

function* fetchDataLayout(action) {
    const {params,onSuccess,onFailure} = action.payload;
    yield put(setLoading(true));
    try {
//gọi api rồi
        const response = yield call(fetchLayoutData, params);
        //Gán vào localStorage biến thành công hay còn gọi là response Success
        yield put(setData(response));
        if (onSuccess) {

            onSuccess(response); // Gọi callback thành công
        }
        yield put(errors([]));
    } catch (error) {
        //Gán vào localStorage biến lỗi response Fail

        yield put(errors(error));
        if (onFailure) {
            onFailure(error); // Gọi callback thất bại
        }
    }finally {
        yield put(setLoading(false));
    }
}

// Saga watcher
function* watchApiCall() {
     yield takeLatest(API_GET_LAYOUT, fetchDataLayout);
}

export default watchApiCall;